import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Icon,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import { RxLightningBolt } from 'react-icons/rx';
import { RiDeleteBinLine } from 'react-icons/ri';

import { MdQuiz } from 'react-icons/md';

import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../Context/AuthContext';
import { getAuthToken } from '../Helpers/script';

const NotesCard = ({ note, handleDelete }) => {
  const history = useHistory();
  const { currentUser } = useAuth();

  const openStudyChat = () => {
    console.log('Open Study Chat');
    history.push(
      `/smartNotes?id=${note?.studyNotesKey}&course=${note?.courseName}`
    );
  };

  const createQuizHandler = () => {
    history.push(
      `/configureQuiz?notesId=${note?.studyNotesKey}&course=${note?.courseName}`
    );
  };

  return (
    <Box
      h="115px"
      p="15px"
      boxShadow="2px 5px 40px 9px rgba(112, 144, 176, 0.08)"
      width="100%"
      minW="fit-content"
      borderRadius="14px"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      color="#120F43"
      cursor="pointer"
    >
      <Flex
        display="flex"
        alignItems="center"
        w="100%"
        onClick={openStudyChat}
        // justifyContent="space-between"
        // flexDirection={{ base: 'column', sm: 'row' }}
      >
        {/* ICON SPARK */}
        <Flex
          background="#F9F5FF"
          alignItems="center"
          justifyContent="center"
          borderRadius="50%"
          padding="0.5rem"
          mr="6px"
        >
          <Icon
            as={RxLightningBolt}
            height="2rem"
            width="2rem"
            p="0.3rem"
            color="#7F56D9"
            bg="#F4EBFF"
            borderRadius="50%"
          />
        </Flex>

        {/* FIELD NAME  */}
        <Flex
          alignItems={{ md: 'center' }}
          justifyContent="space-between"
          w="100%"
          flexDirection={{ base: 'column', sm: 'row' }}
          mr="0.8rem"
        >
          <Text fontSize={{ base: '0.9rem', sm: '1.2rem' }}>{note?.name}</Text>
          <Flex
            fontSize={{ base: '0.8rem', sm: '1rem' }}
            width={{ base: 'fit-content', md: '17rem' }}
            justifyContent="space-between"
            mr={{ base: '0', sm: '2rem' }}
          >
            <Text color="#9F9EB8" pr="0.4rem">
              {note?.courseName}
            </Text>
            <Text color="#9F9EB8" pr="0.4rem">
              {note?.creationTime
                ? new Date(note?.creationTime).toLocaleDateString('en-GB')
                : '-'}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex>
        {/* <Button> */}
        <Icon
          as={RiDeleteBinLine}
          height={{ base: '1rem', sm: '1.4rem' }}
          width={{ base: '1rem', sm: '1.4rem' }}
          title="Delete"
          m="5px"
          onClick={() => handleDelete(note)}
          viewBox={{ base: '0 0 1rem 1rem', sm: '0 0 1.4rem 1.4rem' }}
          // color="#bd2d2d"
        />
        {/* </Button> */}

        <Icon
          as={MdQuiz}
          height={{ base: '1rem', sm: '1.4rem' }}
          width={{ base: '1rem', sm: '1.4rem' }}
          title="Create Quiz"
          m="5px"
          onClick={createQuizHandler}
          color="#7F56D9"
          viewBox={{ base: '0 0 1rem 1rem', sm: '0 0 1.4rem 1.4rem' }}
        />
      </Flex>
    </Box>
  );
};

const QuizListCard = ({ note, handleDelete }) => {
  const history = useHistory();

  const openQuiz = () => {
    history.push(`/quiz?id=${note?.key}&courseName=${note?.courseName}`);
  };

  return (
    <Box
      h="115px"
      p="15px"
      boxShadow="2px 5px 40px 9px rgba(112, 144, 176, 0.08)"
      width="100%"
      minW="fit-content"
      borderRadius="14px"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      color="#120F43"
      cursor="pointer"
    >
      <Flex
        display="flex"
        alignItems="center"
        w="100%"
        onClick={openQuiz}
        // justifyContent="space-between"
        // flexDirection={{ base: 'column', sm: 'row' }}
      >
        {/* ICON SPARK */}
        <Flex
          background="#F9F5FF"
          alignItems="center"
          justifyContent="center"
          borderRadius="50%"
          padding="0.5rem"
          mr="6px"
        >
          <Icon
            as={RxLightningBolt}
            height="2rem"
            width="2rem"
            p="0.3rem"
            color="#7F56D9"
            bg="#F4EBFF"
            borderRadius="50%"
          />
        </Flex>

        {/* FIELD NAME  */}
        <Flex
          alignItems={{ md: 'center' }}
          justifyContent="space-between"
          w="100%"
          flexDirection={{ base: 'column', sm: 'row' }}
          mr="0.8rem"
        >
          <Text fontSize={{ base: '0.9rem', sm: '1.2rem' }}>
            {note?.name}-{note?.courseName}
          </Text>
          <Flex
            fontSize={{ base: '0.8rem', sm: '1rem' }}
            width={{ base: 'fit-content', md: '17rem' }}
            justifyContent="space-between"
            mr={{ base: '0', sm: '2rem' }}
          >
            <Text color="#9F9EB8" pr="0.4rem">
              {note?.score ?? '-'}
            </Text>
            <Text color="#9F9EB8" pr="0.4rem">
              {note?.creationTime
                ? new Date(note?.creationTime).toLocaleDateString('en-GB')
                : '-'}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex>
        {/* <Button> */}
        <Icon
          as={RiDeleteBinLine}
          height={{ base: '1rem', sm: '1.4rem' }}
          width={{ base: '1rem', sm: '1.4rem' }}
          title="Delete"
          m="5px"
          onClick={() => handleDelete(note)}
          viewBox={{ base: '0 0 1rem 1rem', sm: '0 0 1.4rem 1.4rem' }}
          // color="#bd2d2d"
        />
        {/* </Button> */}
      </Flex>
    </Box>
  );
};

export default NotesCard;

export { NotesCard, QuizListCard };
